import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_PROFILES_LIST,
  GET_PROFILES_LIST_SUCCESS,
  GET_PROFILES_LIST_ERROR,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  ADD_PROFILE,
  ADD_PROFILE_SUCCESS,
  ADD_PROFILE_ERROR,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  DELETE_PROFILE,
  DELETE_PROFILE_SUCCESS,
  DELETE_PROFILE_ERROR,
} from '../../constants/ActionTypes';
// Model
/* eslint-disable import/named */
import { deserialize } from '../../models/profile';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.profile;
const profile = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullProfile') {
        return {
          ...state,
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'currentProfile':
          key = 'current';
          break;
        case 'addProfile':
          key = 'add';
          break;
        case 'updateProfile':
          key = 'update';
          break;
        case 'deleteProfile':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_PROFILES_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_PROFILES_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_PROFILES_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_PROFILE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_PROFILE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_PROFILE:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_PROFILE_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: action.error,
        },
      };
    case ADD_PROFILE_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // UPDATE
    case UPDATE_PROFILE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // DELETE
    case DELETE_PROFILE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_PROFILE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_PROFILE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    default:
      return state;
  }
};

export default profile;



// WEBPACK FOOTER //
// ./reducers/user/profile.js